import i18n from "@/common/lang.serivce";
import { ROLE_PERMISSION_DICTIONARIES_MANAGEMENT } from "../common/permissions";

const Menu = [
  {
    header: i18n.t("mainMenu"),
    route: {
      meta: {}
    }
  },
  {
    group: "apps",
    name: "Dashboard"
  },
  {
    group: "apps",
    name: "Vehicles"
  },
  {
    group: "apps",
    name: "Issues"
  },
  {
    group: "apps",
    name: "ServiceReports"
  },
  {
    group: "apps",
    name: "ReviewReports"
  },
  {
    route: {
      meta: {
        title: i18n.t("reports"),
        icon: "timeline"
      }
    },
    items: [
      {
        name: "BasicReport",
        component: "BasicReport"
      },
      {
        name: "DetailedReport",
        component: "DetailedReport"
      },
      {
        name: "IssuesReport",
        component: "IssuesReport"
      },
      {
        name: "ComprehensiveReport",
        component: "ComprehensiveReport"
      },
      {
        name: "SparePartReport",
        component: "SparePartReport"
      }
    ]
  },
  {
    route: {
      meta: {
        title: i18n.t("menu.coefficients"),
        icon: "square_foot"
      }
    },
    items: [
      {
        name: "CoefficientReadinessList",
        component: "CoefficientReadinessList"
      },
      {
        name: "CoefficientReliabilityList",
        component: "CoefficientReliabilityList"
      }
    ]
  },
  {
    group: "apps",
    name: "Users"
  },
  {
    route: {
      meta: {
        title: i18n.t("dictionaries"),
        icon: "announcement",
        permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
      }
    },
    items: [
      {
        name: "DictionaryComponents",
        component: "DictionaryComponents"
      },
      {
        name: "FaultMessages",
        component: "FaultMessages"
      },
      {
        name: "SpareParts",
        component: "SpareParts"
      },
      {
        name: "DictionarySparePartTypes",
        component: "DictionarySparePartTypes"
      },
      {
        name: "Fleets",
        component: "Fleets"
      }
    ]
  }
];

export default Menu;
